export const CRITICAL = 2;
export const MEDIUM = 1;
export const LOW = 0;

export const CongestionLevels = {
  CRITICAL,
  MEDIUM,
  LOW,
};
